/* eslint-disable react/sort-comp */
/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import {
  Button,
  Table,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  Pagination,
  Loading,
  TableCell,
  TableToolbar,
  DataTableSkeleton,
} from 'carbon-components-react';
import { Link } from 'react-router-dom';
import View16 from '@carbon/icons-react/lib/view--filled/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';

import '../../scss/custom.scss';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  STATUS,
  apioperation,
  entitiesLabels,
  CarType,
} from '../../helpers/Constants';
import { api, registry } from '../../helpers/api/api';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { StatusTag } from '../../helpers/PageBreadCrumb';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import AuditCAModal from './AuditCAModal';
import { IsEditable } from '../../helpers/authorization/Policies';
import { Online } from '../common/OnLineOffLine';

export default class AuditCAList extends Component {
  initialState = (props) => {
    const initialState = {
      idAuditEdit: props.idAuditEdit,
      idAnswer: props.idAnswer,
      idCar: props.idCar,

      // modal insert/edit
      keyModalCA: `modalCA_${new Date().getTime()}`,
      editModelCA: null,
      isEditModalCA: false,
      isOpenModalCA: false,
      addCountItems: 0,
      isOpenDeleteModal: false,
      isDeleting: false,
      idToDelete: false,
      appType: null,
      appNationality: null,
      appStatus: null,
      //auditCA : this.props.auditCA ? this.props?.auditCA.filter( x =>  this.props.listCa?.itemList.some(y => y.id == x.id) ) : []
    };
    return initialState;
  };

  constructor(props) {
    super(props);

    this.state = {
      ...this.initialState(props),
    };

    this.backendBaseUrl = `/audit/${this.state.idAuditEdit}/answer/${this.state.idAnswer}/car/${this.state.idCar}/ca/`;
    this.baseUrl= `/audit/${this.state.idAuditEdit}/${this.props.isNewCarManagement}/answer/${this.state.idAnswer}/car/${this.state.idCar}/ca/`;
  }

  baseUrl;
  backendBaseUrl;

  componentDidMount() {
    this.getType();
    this.getCountry();
    this.getStatus();
  }

  getCAs = (model) => this.props.getCAs(model);

  getStatus = () => {
    registry
      .getAll('status')
      .then((response) => {
        let { data } = response;
        data = data != null ? data.filter((item) => item.id !== STATUS.Approved) : [];
        this.setState({
          appStatus: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.STATUS, apioperation.GET)
        );
      })
      .finally(() => {});
  };

  getType() {
    registry
      .getAll('infooriginator')
      .then((response) => {
        let { data } = response;
        data = data != null ? data.map((item) => ({ id: item.name, name: item.name })) : [];
        this.setState({
          appType: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.TYPEAUDIT, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getCountry() {
    api
      .getAll('/country')
      .then((response) => {
        const { data } = response;
        this.setState({
          appNationality: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.COUNTRY, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  detailCA = (id) => {
    this.props.history.push(this.baseUrl + id);
  };

  /** ********CA******************* */

  toggleModalCA = (open) => {
    this.setState({ isOpenModalCA: open });
  };

  addCA = () => {
    this.setState({ keyModalCA: `modalCA_${new Date().getTime()}` });
    this.setState({ isEditModalCA: false, isOpenModalCA: true, editModelCA: null });
  };

  editModalCA = (id) => {
    this.setState({ keyModalCA: `modalCA_${new Date().getTime()}` });
    const item = this.props.auditCA.find((el) => el.id === id);
    const canEditResource = this.props.car && {
      email:
        this.props.car.owner != null
          ? this.props.car.owner.email
          : this.props.car.ownerSaipem.email, // CAR Owner
    };
    const editEffectiveness = IsEditable(
      'Audit',
      'CARManagement',
      this.props.user,
      this.props.car.idStatus,
      'Effectiveness',
      canEditResource
    );
    this.setState({
      editModelCA: item,
      isEditModalCA: true,
      isOpenModalCA: true,
      editEffectiveness,
    });
  };

  handleSaveModalCA = (datiForm) => {
    if (!datiForm) return;

    this.setState({
      isSubmitted: true,
    });

    if (!this.state.isEditModalCA) {
      datiForm.idStatus = 1;
      datiForm.idAuditCAR = this.state.idCar;
      datiForm.status = {
        id: 1,
        name: 'Draft',
        planningName: 'Draft',
        reportingName: 'Opened',
        carManagementName: 'Assigned',
        caManagementName: 'Draft',
      };
      if (this.props.isNewCarManagement !== 0)
      {
        if (this.props.car.owner != null)
        {
          datiForm.owner.email = this.props.car.owner.email;
          datiForm.owner.fullname = this.props.car.owner.fullname;
          datiForm.owner.IdEmployer = this.props.car.owner.id;
          datiForm.owner.BadgeNumber = this.props.car.owner.ghrS_ID;
          //datiForm.owner.Type = ???
          const country = (this.state.appNationality || []).find((el) => el.id == this.props.car.owner.countryId);
          datiForm.owner.nationality = country ? country.name : '';
        }
        else if (this.props.car.ownerSaipem != null)
        {
          datiForm.owner.email = this.props.car.ownerSaipem.email;
          datiForm.owner.fullname = this.props.car.ownerSaipem.fullname;
          datiForm.owner.IdEmployer = this.props.car.ownerSaipem.Id;
          //datiForm.owner.Type = ???
        }
      }
    }

    const method = this.state.isEditModalCA
      ? api.put(this.backendBaseUrl, datiForm, datiForm.id)
      : api.post(this.backendBaseUrl, datiForm);

    method
      .then((response) => {
        if (response.status === 200) {
          this.getCAs(datiForm);
          if (!this.state.isEditModalCA) {
            this.updatePagination();
          }
          this.setState({
            isOpenModalCA: false,
            keyModalCA: `modalCA_${new Date().getTime()}`,
          });
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(
              entitiesLabels.CA,
              this.state.isEditModalCA ? apioperation.PUT : apioperation.POST
            )
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(
            error,
            entitiesLabels.CA,
            this.state.isEditModalCA ? apioperation.PUT : apioperation.POST
          )
        );
      })
      .finally(() => {
        this.setState({
          isSubmitted: false,
        });
      });
  };

  updatePagination = async () => {
    await this.setState(() => ({
      addCountItems: this.state.addCountItems + 1,
    }));
  };

  showLoading() {
    const show = this.state.isSubmitted;
    const descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active withOverlay description={descr} />;
    // return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  confirmDeleteCA = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  deleteItemCA = () => {
    const id = this.state.idToDelete;

    this.setState({
      isDeleting: true,
    });

    api
      .delete(this.backendBaseUrl, id)
      .then((response) => {
        if (response.status == 200) {
          this.setState({
            idToDelete: null,
            isOpenDeleteModal: false,
          });
          this.onCloseConfirm();
          this.getCAs(id);
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.CA, apioperation.DELETE)
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CA, apioperation.DELETE)
        );
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        });
      });
  };
  /** ********Fine CA******************* */

  getStatusId = (idRow) => {
    const r = this.props.auditCA.find((el) => el.id == idRow);
    return r && r.idStatus;
  };

  render() {
    const rows = this.props.auditCA || [];

    // this.props.listCa?.itemList || [];

    const CAModalProps = {
      key: this.state.keyModalCA,
      title: 'CA',
      editModel: this.state.editModelCA,
      isOpenModal: this.state.isOpenModalCA,
      isEditModal: this.state.isEditModalCA,
      isNewCarManagement: this.props.isNewCarManagement,
      toggleModal: this.toggleModalCA,
      save: this.handleSaveModalCA,

      appType: this.state.appType,
      appNationality: this.state.appNationality,
      appStatus: this.state.appStatus,
      car: this.props.car,
      editEffectiveness: this.state.editEffectiveness,
      isDisabled: this.props.isDisabled,
    };

    const getNameCAById = (id) => {
      if (id == null) return '';
      const element = rows.find((el) => el.id == id);
      return element && element.owner && element.status
        ? `${element.owner.fullname} - ${element.dueDate} - ${element.status.caManagementName}`
        : '';
    };

    const confirmDelProps = () => ({
      idToDelete: this.state.idToDelete,
      nameItem: getNameCAById(this.state.idToDelete),
      isDeleting: this.state.isDeleting,
      open: this.state.isOpenDeleteModal, // open state
      onCloseConfirm: this.onCloseConfirm, // no click
      deleteItem: this.deleteItemCA, // yes click fn()
    });
    const paginationProps = () => ({
      page: this.props.currentPage || 1,
      totalItems: this.props.rowCount + this.state.addCountItems || 0,
      pageSize: this.props.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.props.handleChangePaging,
    });
    const colSpan = 6;
    // partial page
    return (
      <>
        <ConfirmAlertCustom {...confirmDelProps()} />
        <div className="bx--row container-page">
          {this.showLoading()}
          <div className="bx--col-lg-12 bx--col-md-12 container-page">
            <div>
              <h3 className="title--medium--expressive">
                {this.props.car.carType == CarType.NC.Code ? 'CA/Corrective Action' : 'CA/Recommended Action'}
              </h3>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-12 container-page">
                <TableToolbar>
                  <h3 className="title--medium max-width" />
                  {this.props.isDisabled || this.props.statusCar > 2  ? null : (
                    <Button onClick={() => this.addCA()} renderIcon={Add16} disabled={this.props.isNewCarManagement > 0 && rows !== null && rows.length >= 1 ? true : false} >
                      Add new
                    </Button>
                  )}
                </TableToolbar>

                <TableContainer className="bx--grid--full-width">
                  {this.props.isLoading ? (
                    <DataTableSkeleton headers={[]} rowCount={10} zebra={false} compact={false} />
                  ) : (
                    <Table>
                      <TableHead className="colorgray">
                        <TableRow>
                          <TableHeader>Owner</TableHeader>
                          <TableHeader>Owner Type</TableHeader>
                          <TableHeader>Due Date</TableHeader>
                          <TableHeader>Status</TableHeader>
                          <TableHeader className="align-center">Actions</TableHeader>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows == null || rows.length == 0 ? (
                          <NoRecordsPlaceholder labelText="No Records" colSpan={colSpan} />
                        ) : (
                          rows.map((item) => (
                            <TableRow key={`row_${item.id}`}>
                              <TableCell key={`cell_fullname_${item.id}`}>
                                {item.owner && item.owner.fullname}
                              </TableCell>
                              <TableCell key={`cell_type_${item.id}`}>
                                {item.owner && item.owner.type}
                              </TableCell>
                              <TableCell key={`cell_dueDate_${item.id}`}>
                                {switchDateFormat(item.dueDate, 'date')}
                              </TableCell>
                              <TableCell key={`cell_status_${item.id}`}>
                                <StatusTag value={item.status && item.status.caManagementName} />
                              </TableCell>
                              <TableCell
                                key={`action-${item.id}`}
                                className="tableActions align-center"
                              >
                                <div>
                                  <Online>
                                    <Link to={this.baseUrl + item.id + (this.props.hash || '')}>
                                      <Button
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Detail"
                                        kind="ghost"
                                      />
                                    </Link>
                                  </Online>
                                  <Button
                                    onClick={() => this.editModalCA(item.id)}
                                    size="small"
                                    renderIcon={Edit16}
                                    iconDescription="Edit"
                                    kind="ghost"
                                  />
                                  <Online>
                                    {this.props.isDisabled || this.props.statusCar >= 3 ? null : (
                                      <Button
                                        onClick={() => this.confirmDeleteCA(item.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                      />
                                    )}
                                  </Online>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  )}
                </TableContainer>
                <div className="footer-pagination">
                  <Pagination {...paginationProps()} />
                </div>
                <AuditCAModal {...CAModalProps} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
